export const EDIT_SUCCESS = 'Мобильное приложение обновлено';
export const EDIT_ERROR = 'Не удалось обновить мобильное приложение';
